import React from "react";
import styled from "styled-components";
import fontSize from "../../../theme/fonts/FontTheme";
import colors from "../../../theme/color/ColorTheme";
import LogoDefaultText from "../../logo/LogoDefaultText";

const Footer = styled.footer``;

const Container = styled.div`
  width: 80vw;
  margin: 0 auto;
  display: grid;
  align-items: center;
  padding: 40px 24px;
  box-sizing: border-box;
  border-top: 1px solid ${colors.line};
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 950px) {
    display: flex;
    gap: 16px;
    width: 90vw;
    flex-direction: column;
  }
`;

const Left = styled.div`
  span {
    display: block;
    font-size: ${fontSize.xs};
    letter-spacing: 0.08rem;
  }
`;

const Center = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  p {
    color: #4f4f4f;
    font-size: ${fontSize.xxs};
  }

  a {
    cursor: pointer;
    letter-spacing: 0.08rem;
    font-size: ${fontSize.xxs};
    color: ${colors.black};
    transition: all 0.3s ease-in;

    &:hover {
      color: ${colors.primaryGray};
    }
  }
  a:link,
  a:visited,
  a:active {
    text-decoration: none;
  }
`;

const Right = styled.div`
  gap: 8px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 950px) {
    display: none;
  }
`;

const Socials = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 24px;

  a {
    cursor: pointer;
    position: relative;
    letter-spacing: 0.08rem;
    font-size: ${fontSize.xs};
    color: ${colors.black};
    transition: all 0.2s ease-in;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 100%;
      height: 1px;
      background-color: white;
      transform: translateX(-50%) scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease, background-color 0.3s ease;
    }

    &:hover {
      color: black;

      &::after {
        transform: translateX(-50%) scaleX(1);
        background-color: black;
      }
    }
  }

  a:link,
  a:visited,
  a:active {
    text-decoration: none;
  }
`;

function FooterSection() {
  return (
    <Footer>
      <Container>
        <Left>
          <span>Intl (En)</span>
        </Left>
        <Center>
          <LogoDefaultText />
          <p>© 2025, Peak Pashmina Official Online Store </p>
          <a
            href="https://inaing.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Developed by @inaing
          </a>
        </Center>
        <Right>
          <Socials>
            <li>
              <a
                href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Wechat
              </a>
            </li>
          </Socials>
        </Right>
      </Container>
    </Footer>
  );
}

export default FooterSection;
